<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableBackPlanDate"
      style="width: 100%"
      border
    >
      <template slot-scope="{ row, index }" slot="delete">
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            @click="backPlanDelmodal = true"
            v-hasPermission="['monitor:backPlanMonitor:delete']"
            >{{ $t("alarms.common.delete") }}</Button
          >
        </span>
        <Button
          type="info"
          size="small"
          @click="rowClick(row)"
          v-hasPermission="['monitor:backPlanMonitor:detail']"
          >{{ $t("alarms.common.details") }}</Button
        >
      </template>
    </Table>
    <!-- 删除实例模式框 -->
    <Modal v-model="backPlanDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color: #f60; text-align: center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align: center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ backPlanName }}
          {{ $t("alarms.common.allWarningRules") }} ？
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeBackPlan()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableBackPlanVue = {};
export default {
  name: "TableBackPlan",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      backPlanDelmodal: false,
      isDisable: false,
      modal_loading: false,
      val: "",
      region: "",
      accountId: "",
      backPlanName: "",
      columns: [
        {
          title: this.$t("alarms.backPlan.accountTypeName"),
          key: "accountTypeName"
        },
        {
          title: this.$t("alarms.backPlan.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("alarms.backPlan.backupPlanId"),
          key: "backupPlanId"
        },
        {
          title: this.$t("alarms.backPlan.backupPlanName"),
          key: "backupPlanName"
        },
        {
          title: this.$t("alarms.backPlan.creationDate"),
          key: "creationDate"
        },
        {
          title: this.$t("common.operation"),
          slot: "delete"
        }
      ],
      tableBackPlanDate: []
    };
  },
  beforeCreate: function() {
    tableBackPlanVue = this;
  },
  created() {
    eventBus.$on("companyId", function(val) {
      tableBackPlanVue.companyId = val;
    });
    eventBus.$on("accountType", function(val) {
      tableBackPlanVue.accountType = val;
    });
    eventBus.$on("accountName", function(val) {
      tableBackPlanVue.accountName = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableBackPlanVue.getBackPlanData();
    },
    // 分页显示数据
    /****************************************************/
    getBackPlanData: function() {
      //列表分页
      this.$api.resourceAwsBackupPlan
        .pageBackUp({
          pageNum: this.current,
          pageSize: this.pageSize,
          companyId: tableBackPlanVue.companyId,
          accountType: tableBackPlanVue.accountType,
          accountName: tableBackPlanVue.accountName
        })
        .then(res => {
          this.tableBackPlanDate = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableBackPlanVue.getBackPlanData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableBackPlanVue.getBackPlanData();
    },
    // 销毁regionName
    beforeDestroy: function() {
      eventBus.$off("regionName");
    },
    // 删除
    /****************************************************/
    doDelete: function(index) {
      this.lineIndex = index;
      this.backPlanName = this.tableBackPlanDate[index].accountName;
    },
    removeBackPlan: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //删除
      this.$api.resourceAwsBackupPlan
        .deleteBackUpPlan("id", this.tableBackPlanDate[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableBackPlanVue.getBackPlanData();
            this.isDisable = false;
            this.modal_loading = false;
            this.backPlanDelmodal = false;
            this.$Message.success(this.$t("common.deleteSuccess"));
          }, 1000);
        });
    },
    // 单击行
    /****************************************************/
    rowClick: function(row) {
      this.$router.push({
        path: "/monitor/backPlanDetail/",
        query: {
          id: row.id,
          accountId: row.accountId,
          backupPlanName: row.backupPlanName,
          region: row.region,
          accountType: row.accountType,
          accountName: row.accountName,
          backupPlanId: row.backupPlanId,
          accountTypeName: row.accountTypeName
        }
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/backPlan/TableBackPlan.vue